import api from '../utils/api';

// Create student history
export const createStudentHistory = async (studentHistoryData, headers) => {
  try {
    const response = await api.post('/api/studentHistory', studentHistoryData,  headers );

    return response.data;
  } catch (error) {
    console.error('Error creating or updating student history:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch all student histories
export const getAllStudentHistories = async (headers) => {
  try {
    const response = await api.get('/api/studentHistory',  headers );
    console.log("data", response.data)
    return response.data;
  } catch (error) {
    console.error('Error fetching all student histories:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific student history by ID
export const getStudentHistoryById = async (id, headers) => {
  try {
    const response = await api.get(`/api/studentHistory/${id}`,  headers );
    console.log(" getStudentHistoryById ", response.data)
    return response.data;
  } catch (error) {
    console.error('Error fetching student history by ID:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch student history by student ID and academicYearId
export const getStudentHistoryByStudentAndYear = async (studentId, academicYearId, headers) => {
  try {
    const response = await api.get(`/api/studentHistory/student/${studentId}/year/${academicYearId}`,  headers );
    console.log("getStudentHistoryByStudentAndYear", response.data)
    return response.data;
  } catch (error) {
    console.error('Error fetching student history by student ID and academicYearId:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch student history by student ID for all years
export const getStudentHistoryByStudentId = async (studentId, headers) => {
  try {
    const response = await api.get(`/api/studentHistory/student/${studentId}`,  headers );
    return response.data;
  } catch (error) {
    console.error('Error fetching student history by student ID:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update student history by ID
export const updateStudentHistory = async (id, studentHistoryData, headers) => {
  try {
    const response = await api.put(`/api/studentHistory/${id}`, studentHistoryData,  headers );
    return response.data;
  } catch (error) {
    console.error('Error updating student history:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete student history by ID
export const deleteStudentHistory = async (id, headers) => {
  try {
    const response = await api.delete(`/api/studentHistory/${id}`,  headers );
    return response.data;
  } catch (error) {
    console.error('Error deleting student history:', error.response ? error.response.data : error.message);
    throw error;
  }
};
